import React, { useEffect } from "react";
import client from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useCart } from "@/context/CartContext";

/**
 * Side-effect component: posts the user's cart to /cart/track every time it changes
 * (debounced) so we can email a recovery nudge if they abandon. Mounted under both
 * AuthProvider and CartProvider in App.js. Returns null.
 */
export default function CartTracker() {
  const { user } = useAuth();
  const { items } = useCart();

  useEffect(() => {
    if (!user?.email) return;
    if (!items || items.length === 0) return;
    const handle = setTimeout(() => {
      client.post("/cart/track", {
        email: user.email,
        items: items.map((i) => ({
          product_id: i.product_id,
          title: i.title,
          image_url: i.image_url,
          unit: i.unit,
          size: i.size,
          color: i.color || null,
          quantity: i.quantity,
        })),
      }).catch((e) => console.warn("Cart tracking failed:", e?.message || e));
    }, 1500);
    return () => clearTimeout(handle);
  }, [user?.email, items]);

  return null;
}
